import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

type Props = {
  /** pending | processing | ready | failed (любой другой не-ready тоже даёт плейсхолдер). */
  status: string
  url: string | null
  alt?: string
  /** Подпись плитки-плейсхолдера (failed / нет картинки). По умолчанию "—". */
  fallbackLabel?: string
  /** Нативный тултип плитки-плейсхолдера (например error_message). */
  errorTitle?: string | null
  className?: string
}

/**
 * Плитка кадра с асинхронным статусом извлечения: картинка для ready,
 * спиннер для pending/processing, плейсхолдер с подписью для failed.
 * Тернарник — по образцу animatic-segment-reference-panel.
 */
export function FrameStatusTile({ status, url, alt, fallbackLabel = "—", errorTitle, className }: Props) {
  if (status === "ready" && url) {
    return (
      <img src={url} alt={alt ?? ""} className={cn("rounded-lg border border-ui-border object-cover", className)} />
    )
  }
  if (status === "pending" || status === "processing") {
    return (
      <div
        className={cn(
          "flex items-center justify-center rounded-lg border border-ui-border bg-ui-surface-sunken",
          className,
        )}
      >
        <Loader2 className="h-3.5 w-3.5 animate-spin text-ui-link/50" />
      </div>
    )
  }
  return (
    <div
      title={errorTitle ?? undefined}
      className={cn(
        "flex items-center justify-center rounded-lg border border-dashed border-ui-border bg-ui-surface-sunken text-[10px] text-ui-text-secondary",
        className,
      )}
    >
      {fallbackLabel}
    </div>
  )
}
